// utils/variantImage.ts — Foto varian terpilih (SATU-SATUNYA resolver, dipakai LP + form).
// Prioritas: 1) kombinasi form yang cocok (foto per kombinasi, kalau diisi) →
// 2) foto varian PRODUK (products.attributes.variants[].imageUrl → form.productVariants)
// yang opsinya cocok → 3) varian kustom LP (resolveLpVariantImageUrl) → null (gambar default).

export interface ProductVariantLike {
    name?: string;
    optionValues?: string[];
    imageUrl?: string;
}

export function resolveVariantImageUrl(
    combos: Array<{ attributes?: Record<string, string>; imageUrl?: string }> | undefined,
    selected: Record<string, string> | undefined,
    productVariants?: ProductVariantLike[],
): string | null {
    const sel = selected || {};
    const keys = Object.keys(sel).filter(k => sel[k]);
    if (keys.length === 0) return null;
    const vals = keys.map(k => sel[k]);

    if (Array.isArray(combos)) {
        const match = combos.find(c => keys.every(k => c?.attributes?.[k] === sel[k]));
        if (match?.imageUrl) return match.imageUrl;
    }

    if (Array.isArray(productVariants)) {
        // Cocok PENUH dulu (SEMUA nilai terpilih ada di optionValues/name) supaya varian
        // multi-opsi (mis. Hitam + L) tidak salah ambil foto varian yang cuma berbagi
        // satu nilai. Baru longgar (some) sebagai kompatibilitas mundur.
        const full = productVariants.find(pv => {
            const ov = Array.isArray(pv.optionValues) ? pv.optionValues : [];
            const name = pv.name || '';
            return vals.every(v => ov.includes(v) || v === name);
        });
        if (full?.imageUrl) return full.imageUrl;
        const loose = productVariants.find(pv =>
            (Array.isArray(pv.optionValues) && pv.optionValues.some(o => vals.includes(o))) ||
            (pv.name ? vals.includes(pv.name) : false));
        if (loose?.imageUrl) return loose.imageUrl;
    }

    return null;
}

// Varian kustom LP (landing page `productData.variants`) — opsi terpilih punya `image`.
// Dipakai HANYA bila LP tidak pakai varian form, atau form tak punya foto varian.
export function resolveLpVariantImageUrl(
    variants: Array<{ name?: string; options?: Array<{ label?: string; value?: string; image?: string }> }> | undefined,
    selected: Record<string, string> | undefined,
): string | null {
    if (!Array.isArray(variants) || !selected) return null;
    for (const v of variants) {
        if (!v?.name) continue;
        const pick = selected[v.name];
        if (!pick) continue;
        const opt = (v.options || []).find(o => (o?.label ?? o?.value) === pick);
        if (opt?.image) return opt.image;
    }
    return null;
}
